
import { React } from 'react'
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import  Home  from './Pages/Home'
import Error from "./Pages/Error"
import Play from "./Pages/Play"
import Score from "./Pages/Score"
import Navbar from "./Components/Navbar"



function App() {
  return (
    <Router>
      <Navbar></Navbar>
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/play/:id">
          <Play/>
        </Route>
        <Route path="/score/:score">
          <Score />
        </Route>
        <Route path="*">
          <Error />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
